import React from "react";
import ComboWithOptions from "./ComboWithOptions";
import GenericList from "./GenericList";
import FloatInput from "../formElements/FloatInput";
import BooleanInput from "../formElements/BooleanInput";


function SparePartList(props) {

    function handleChange(event, index) {
        let updatedItem = props.data.Pristroje[props.ndx].Nahradne_Diely[index]
        updatedItem[event.target.name] = event.target.value
        props.update(updatedItem, props.ndx, props.index, event.target.name)
    }

    function getAdditionalCells(item, index) {
        return (
            <>
                <ComboWithOptions options={props.data.Nahradne_diely_options} optionDisplay={'Objednavaci_Kod'}
                                  select={props.select}
                                  value={item.emptyCell? "" :`${item['Nahradny_Diel']['Objednavaci_Kod']}`} ndx={props.ndx} index={index}
                                  name="Objednavaci_Kod"
                />
                <td>
                    {!item.emptyCell && <BooleanInput name={'Skladova_Polozka'}
                                value={item['Skladova_Polozka']}
                                ndx={props.ndx} index={index}
                                onChange={(event) => handleChange(event, index)}
                    />}
                </td>
                <td>
                    {!item.emptyCell && <FloatInput name={'Koeficient'}
                                value={`${item['Koeficient']}`}
                                ndx={props.ndx} index={index}
                                onChange={(event) => handleChange(event, index)}
                    />}
                </td>
                {props.form === "service" &&
                <td>
                    {!item.emptyCell  && <FloatInput name={'Zlava'}
                                                    value={`${item['Zlava']}`}
                                                    ndx={props.ndx} index={index}
                                                    onChange={(event) => handleChange(event, index)}
                    />}
                </td> }
            </>
        )
    }

    function getAdditionalEmptyCells() {
        return (
            <>
                <ComboWithOptions options={props.data.Nahradne_diely_options} optionDisplay={'Objednavaci_Kod'}
                                  select={props.select}
                                  value="" ndx={props.ndx} index={null} stateResetOnChange={true}
                                  name="Objednavaci_Kod"/>
                <td/>
                <td/>
            </>
        )
    }

    return (
        <GenericList label="Náhradné diely"
                     headers={props.form === "service" ?
                         ['Názov', 'Objednávací kód', 'Skl. pol.', 'Koeficient', 'Zľava %', 'ks', 'Nákup €/ks', 'Predaj €/ks', 'Akcie']:
                         ['Názov', 'Objednávací kód', 'Skl. pol.', 'Koeficient', 'ks', 'Nákup €/ks', 'Predaj €/ks', 'Akcie']}
                     mainColumnName="Nazov"
                     list={props.data.Pristroje[props.ndx].Nahradne_Diely}
                     options={props.data.Nahradne_diely_options}
                     optionDisplay={'Nazov'}
                     select={props.select}
                     value={props.data.Pristroje[props.ndx].Nahradne_Diely}
                     ndx={props.ndx}
                     update={props.update}
                     delete={props.delete}
                     part={props.data.Pristroje[props.ndx].Nahradne_Diely}
                     singleName="Nahradny_Diel"
                     instanceName="Nazov"
                     getAdditionalCells={getAdditionalCells}
                     getAdditionalEmptyCells={getAdditionalEmptyCells}
                     separateSellPrice={true}
        />

    )
}

export default SparePartList
